import { useContext, useState } from 'react';
import './SignInForm.css';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { Navigate, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthProvider';

function SignInForm() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.email || !formData.password) {
      setError('Please enter both email and password.');
      return;
    }
    try {
      await signInWithEmailAndPassword(auth, formData.email, formData.password);
      setError('');
      navigate('/', { replace: true });
    } catch (firebaseError) {
      console.error(firebaseError);
      setError('Email or password is wrong or user does not exist.');
    }
  };

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="auth-shell">
      <div className="card sign-in-card">
        <h1>FTV Notifications</h1>
        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-field">
            <span>Email</span>
            <input
              type="email"
              name="email"
              placeholder="team mail id"
              value={formData.email}
              onChange={handleChange}
              autoComplete="username"
            />
          </label>

          <label className="auth-field">
            <span>Password</span>
            <input
              type="password"
              name="password"
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              autoComplete="current-password"
            />
          </label>

          {error && <p className="error">{error}</p>}

          <button type="submit">Sign in</button>
        </form>
      </div>
    </div>
  );
}

export default SignInForm;

